import { useLoading } from "../Contexts/LoadingContext";
import '../Styles/Spinner.css';

import { useEffect } from 'react';

export function Spinner() {

    const { loading } = useLoading();

    useEffect(() => {
        let spinner_container = document.getElementById('spinner_container');
        if(loading) {
            spinner_container.classList.add('show');
        }
        else {
            spinner_container.classList.remove('show');
        }
    }); 
    
    return (
        <div className='spinner-container' id='spinner_container'>
            <div className="loader"></div>
        </div>
    )
}
